import BaseSelector, { ALL_OPTION_VALUE } from '@src/components/BaseSelector';
import { useScheduleTemplates } from './hooks/useScheduleTemplates';

export const ScheduleTemplateSelector = ({
  onChange,
  value = [],
  organizationId,
  divisionIds,
  templateIds,
  exactMatch,
}) => {
  const idsToPreload = templateIds?.filter(id => id !== ALL_OPTION_VALUE);

  const { items, loading, handlePopupScroll, search, reset } = useScheduleTemplates({
    orgId: organizationId,
    divisionIds,
    templateIds: idsToPreload,
    exactMatch,
  });

  return (
    <BaseSelector
      items={items}
      loading={loading}
      handlePopupScroll={handlePopupScroll}
      onSearch={search}
      onReset={reset}
      value={value}
      onChange={onChange}
      allValue={ALL_OPTION_VALUE}
      autoSelectAllOnComplete={false}
      allLabelId="scheduleTemplateSelector.allTemplates"
      placeholderId="scheduleTemplateSelector.selectTemplates"
      mode="multiple"
    />
  );
};
